import { BaseApi } from './base.api.js';

export class TenantDirectoryApi extends BaseApi {
    constructor(client, basePath = '/tenant-directory') {
        super(client, basePath);
    }

    async getConfig() {
        const response = await this.client.get(`${this.basePath}/config`);
        return response.data;
    }

    async upsertConfig(data) {
        const response = await this.client.put(`${this.basePath}/config`, data);
        return response.data;
    }

    async listRoleMappings() {
        const response = await this.client.get(`${this.basePath}/role-mappings`);
        return response.data;
    }

    async createRoleMapping(data) {
        const response = await this.client.post(`${this.basePath}/role-mappings`, data);
        return response.data;
    }

    async updateRoleMapping(id, data) {
        const response = await this.client.put(`${this.basePath}/role-mappings/${id}`, data);
        return response.data;
    }

    async deleteRoleMapping(id) {
        const response = await this.client.delete(`${this.basePath}/role-mappings/${id}`);
        return response.data;
    }

    async syncNow() {
        const response = await this.client.post(`${this.basePath}/sync`);
        return response.data;
    }

    async listDirectoryFacets() {
        const response = await this.client.get(`${this.basePath}/facets`);
        return response.data;
    }

    async listDirectoryUsers(params = {}) {
        const response = await this.client.get(`${this.basePath}/users`, { params });
        return response.data;
    }

    async importDirectoryUsers(data) {
        const response = await this.client.post(`${this.basePath}/users/import`, data);
        return response.data;
    }
}
